<template lang="pug">
  .right
    h2 {{title}}
    slot
    p.explain(v-html = 'explain' )
    .img_wrap
      a.p.img1(:href='downloadUrl' target="_blank",  v-if="downloadUrl")
      a.p.img2(:href='androidDownloadUrl' target="_blank", v-if="androidDownloadUrl")
</template>

<script>
export default {
  props: {
    title: String.isRequired,
    explain: String.isRequired,
    downloadUrl: String.isRequired,
    androidDownloadUrl: String,
  },
}
</script>

<style lang="stylus">

</style>
